import { SimpleGrid, Skeleton } from "@chakra-ui/react";
import { GreetingHeader } from "./GreetingHeader";
import { HomeSearchBar } from "./HomeSearchBar";

export const HomeLoading = () => (
  <>
    <GreetingHeader />
    <HomeSearchBar />
    <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="4" data-testid="home-loading">
      <Skeleton height="220px" rounded="lg" />
      <Skeleton height="220px" rounded="lg" />
    </SimpleGrid>
  </>
);
